import memberDetailsService from "@services/memberDetails.service";
import { useriskFactorDetailsStore } from "@stores/riskFactorDetailsStore";
import { formatDisplayDate } from "@utils/helpers";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import { Detail } from "../useRisks";
import './details.scss';
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { Spin } from "antd";
import { TableLocale } from "@components/noDataFound";

export type DetailsProps = {
  type: string;
  factor: number;
  patientID: number;
}

export const Details: React.FC<DetailsProps> = function ({ patientID, type, factor }) {
  const formatters: any = {
    'Date': (date: string) => date ? formatDisplayDate(date, 'YYYY-MM-DD') : ''
  }
  
  const widths: any = [
    {
      key: 'date',
      value: 20
    },
    {
      key: 'code',
      value: 30,
    },
    {
      key: 'cost',
      value: 30,
    },
    {
      key: 'ratio',
      value: 30,
    },
    {
      key: 'description',
      value: 100,
    }
  ]

  const [loading, setloading] = useState<boolean>(true)
  let [details, setdetails] = useState<Detail[]>([])

  
  const [data, setdata] = useriskFactorDetailsStore(state => [state.data, state.setData])

  useEffect(
    () => {
      let details = data[`${type}_${factor}`]

      if (details) {
        setdetails(details)
        setloading(false)
      } else {
        memberDetailsService.fetchRiskScoreFactorDetails(patientID, type, factor).subscribe({
          next: (response) => {
            let details = response?.data?.data?.details || []
            setdetails(details)
            setdata(type, factor, details)
            setloading(false)
          },
          error: (e) => {
            console.log(e);
          },
        })
      }
    },
    [type, factor, patientID]
  )

  let columns: ColumnsType<any> = []

  if (details?.length > 0) {
    columns = Object.keys(details[0]).filter(i => i !== 'key').map(
      header => {
        let formatter = formatters[header]
        let width = widths.filter((i: any) => header.toLocaleLowerCase().includes(i.key)).pop()?.value

        return {
          title: header,
          dataIndex: header,
          width: width,
          render: formatter
        }
      }
    )
  }

  return (
    loading ? <Spin spinning={loading}  indicator={<HealthemSpinner/>}></Spin> :
    <div className="ui-details">
        <Table columns={columns} dataSource={details} pagination={false} scroll={{ y: 240 }} locale={TableLocale}/>
    </div>)
};
